import React from 'react'
import { useConfiguratorContext } from '@augmatica/iframe-interface-react'

import Card from '../Card/Card'

import * as Styled from '../styles'
import { useAppSelector } from '../../hooks'

const ASSEMBLY_ID = 'assembly'

interface Props {
  disabled?: boolean
}

export const FloorPanel: React.FC<Props> = ({ disabled }) => {
  const configurator = useConfiguratorContext()

  const { assetBaseUrl, content } = useAppSelector((state) => state.init)
  const {
    props: { loftLeft, loftRight, loftFloor },
  } = useAppSelector((state) => state.configResult) as any // TODO

  const floorTypes = content?.props?.loft?.floor?.options

  return (
    <Styled.Panel>
      <Styled.Grid $responsive>
        {loftFloor.options.map((option: any, index: any) => {
          if (!floorTypes[index]) return

          return (
            <Card
              key={option.value + index}
              type="lightweight"
              // @ts-expect-error // TODO
              className={!loftLeft.value && !loftRight.value && 'disabled'}
              isSelected={loftFloor.value === option.value}
              onClick={() => {
                configurator.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
                  loftFloor: option.value,
                })
              }}
              dangerouslySetInfo={floorTypes[index]?.description}
              mediaAlt={floorTypes[index]?.title}
              mediaImage={`${assetBaseUrl}/${floorTypes[index]?.image}`}
              title={floorTypes[index]?.title}
              titleLong={floorTypes[index]?.description}
              disabled={disabled || (!loftLeft.value && !loftRight.value)}
            />
          )
        })}
      </Styled.Grid>
    </Styled.Panel>
  )
}

export default FloorPanel
